// 获取utc+8时间戳
export function getUTCTime() {
  var currentTime = new Date()
  // 将当前时间转换为UTC格式并加上8小时
  currentTime.setHours(currentTime.getUTCHours() + 8)
  return currentTime.getTime()
}

// 时间处理 传入秒
export function getDateDiff(seconds) {
  if (seconds) {
    // 计算天数
    var days = Math.floor(seconds / (24 * 3600))
    // 剩余秒数
    seconds %= 24 * 3600
    // 计算小时
    var hours = Math.floor(seconds / 3600)
    // 剩余秒数
    seconds %= 3600
    // 计算分钟
    var minutes = Math.floor(seconds / 60)
    // 剩余秒数
    seconds %= 60
    if (days != 0) {
      return days + 'day ' + hours + 'h ' + minutes + 'min ' + seconds + 's'
    }
    if (hours != 0) {
      return hours + 'h' + minutes + 'min ' + seconds + 's'
    }
    if (minutes != 0) {
      return minutes + 'min ' + seconds + 's'
    }
    if (seconds != 0) {
      return seconds + 's'
    }
  }
  // seconds为假，则返回0
  else {
    return 0
  }
}
